import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';


const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

// Titlecloudcompute
function SohoVN() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("소호형(한비로구성도)")} */}
                        {/* {Contentcloudcard("","")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='MuiGrid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Cấu hình Kubernetes riêng tư nhỏ gọn</p>",

                                `
                                <p class='typo-14'>Triển khai một cụm Kubernetes nhỏ gọn trên nền tảng máy chủ ảo Proxmox VE, phù hợp cho nhóm nhỏ hoặc startup.</p>
                                <p class='typo-14'>Cấu trúc gồm các node Master và Worker chạy trên VM, bắt đầu từ 2 máy chủ trở lên là đủ để xây dựng một cluster riêng tư.</p>
                                <p class='typo-14'>&nbsp;</p>
                                <ul>
                                    <li><p class='typo-14'>Gọn nhẹ và hiệu quả: Sử dụng số lượng VM tối thiểu trên Proxmox VE để thiết lập cluster Kubernetes.</p></li>
                                    <li><p class='typo-14'>Phù hợp với nhóm nhỏ: Giải pháp lý tưởng cho các nhóm phát triển hoặc doanh nghiệp nhỏ đang bắt đầu.</p></li>
                                    <li><p class='typo-14'>Tiết kiệm chi phí: Giảm thiểu chi phí đầu tư hạ tầng ban đầu.</p></li>
                                    <li><p class='typo-14'>Triển khai nhanh: Dễ dàng triển khai và mở rộng khi cần thiết.</p></li>
                                    <li><p class='typo-14'>Thích hợp cho môi trường dev/test: Lý tưởng cho các mục đích thử nghiệm, phát triển và học tập.</p></li>
                                </ul>
                                `)}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/back-office-1.png")}</MuiGrid>
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/back-office-2.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default SohoVN;